import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const { t, lang } = useLang();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(phone.trim(), password, name.trim());
      toast.success(t("createAccount"));
      navigate("/");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Register failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="register-page" className="max-w-md mx-auto px-6 py-16">
      <h1 className="font-display text-4xl mb-2">{t("createAccount")}</h1>
      <p className="text-sm text-[#767676] mb-8">{t("brand")}</p>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="name">{t("name")}</Label>
          <Input
            id="name"
            data-testid="register-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            autoComplete="name"
            className="h-11 bg-white mt-1"
          />
        </div>
        <div>
          <Label htmlFor="phone">{t("phone")}</Label>
          <Input
            id="phone"
            type="tel"
            inputMode="tel"
            dir="ltr"
            data-testid="register-phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder={t("phonePlaceholder")}
            required
            autoComplete="tel"
            className="h-11 bg-white mt-1 font-mono"
          />
          <p className="mt-1.5 text-[11px] text-[#767676]">
            {lang === "ar"
              ? "أدخل رقمك مع رمز الدولة، مثال: +963933593799"
              : "Include your country code, e.g. +963933593799"}
          </p>
        </div>
        <div>
          <Label htmlFor="password">{t("password")}</Label>
          <Input
            id="password"
            type="password"
            data-testid="register-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            autoComplete="new-password"
            className="h-11 bg-white mt-1"
          />
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="register-submit"
          className="w-full h-11 rounded-full bg-[#1A1738] hover:bg-[#2C2650] text-white"
        >
          {loading ? t("loading") : t("createAccount")}
        </Button>
      </form>
      <div className="mt-6 text-sm text-[#767676]">
        {t("haveAccount")}{" "}
        <Link to="/login" className="hover-underline text-[#1A1738]" data-testid="go-login">
          {t("signIn")}
        </Link>
      </div>
    </main>
  );
}
